import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { RADIO_PARAMETERS_MONITORING_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { RADIO_PARAMETERS_MONITORING_REPORT } from "../interfaces/dashboard";

export default function RadioParametersMonitoring() {
    const radioParametersMonitoringReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.RADIO_PARAMETERS_MONITORING_REPORT;

    const [radioParametersMonitoringReportTableData, setRadioParametersMonitoringReportTableData] = useState<RADIO_PARAMETERS_MONITORING_REPORT[]>([]);

    useEffect(() => {
        setRadioParametersMonitoringReportTableData(RADIO_PARAMETERS_MONITORING_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="RADIO_PARAMETERS_MONITORING"
        tableColumns={radioParametersMonitoringReportTableColumns}
        tableData={radioParametersMonitoringReportTableData} />
    );
}